var render = function render(){var _vm=this,_c=_vm._self._c;return (
    this.$vuetify.breakpoint.name == 'md' ||
    this.$vuetify.breakpoint.name == 'lg' ||
    this.$vuetify.breakpoint.name == 'xl'
  )?_c('rpDekstop'):_c('v-container',{attrs:{"fill-height":""}},[_c('rpMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }